import { Box, CircularProgress, Popover, Typography } from '@mui/material';
import { ReactElement } from 'react';
import { Styles } from 'common/types';
import { background } from 'common/constants/colors';

const styles: Styles = {
  container: {
    width: 350,
    maxWidth: 350,
    maxHeight: 600,
    overflowY: 'scroll',
    scrollbarWidth: 'none',
  },
  urlContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 1,
  },
  url: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    ':hover': { textDecoration: 'underline', cursor: 'pointer' },
  },
  noneContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    padding: 1,
  },
  urlsHeader: { display: 'flex', justifyContent: 'space-between', p: 1, bgcolor: background },
};

interface Props {
  onClose: () => void;
  anchorElement: HTMLElement | null;
  urls?:
    | {
        url: string;
        path: string;
      }[]
    | null;
  placements?: AsinRecommendationModule.State.PlacementsState;
  isSelected: boolean;
}

export function UrlPopover({ onClose, anchorElement, urls, placements, isSelected }: Props): ReactElement {
  const handleUrlClick = (url: string) => {
    window.open(url, '_blank');
  };

  return (
    <Popover
      anchorEl={anchorElement}
      open={Boolean(anchorElement)}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
    >
      <Box sx={styles.container}>
        {urls &&
          urls.map(url => (
            <Box sx={styles.urlContainer}>
              <Box sx={styles.url} key={url.url} onClick={() => handleUrlClick(url.url)}>
                {url.url}
              </Box>
            </Box>
          ))}
        {isSelected && (
          // eslint-disable-next-line react/jsx-no-useless-fragment
          <>
            {placements?.loading ? (
              <Box sx={styles.noneContainer}>
                <CircularProgress size={14} />
                Retrieving suggestions...
              </Box>
            ) : (
              <Box>
                {placements?.data?.length === 0 ? (
                  <Box sx={styles.noneContainer}>No suggestions found</Box>
                ) : (
                  // eslint-disable-next-line react/jsx-no-useless-fragment
                  <>
                    <Box sx={styles.urlsHeader}>
                      <Typography>Article URL</Typography>
                      <Typography># of visits</Typography>
                    </Box>
                    {placements?.data?.map(urls => (
                      <Box key={urls.url} sx={styles.urlContainer}>
                        <Box sx={styles.url} onClick={() => handleUrlClick(urls.url)}>
                          {urls.url}
                        </Box>
                        <Box>{urls.visits}</Box>
                      </Box>
                    ))}
                  </>
                )}
              </Box>
            )}
          </>
        )}
      </Box>
    </Popover>
  );
}
